/** @format */

import { requestConfigurator } from "./api-service.js";
import { sanityDataset, sanityProjectId } from "./config.js";

const queryServicesPricing = `*[_type == 'servicesPricing'] {
  pageTitle,
  regularAnnualService,
  electronicsRepair,
  bigService,
  otherServices,
  installation,
  refilling
}`;
const queryAirConditions = `*[_type == 'airConditionPricing']{
  ...,
  airConditions[]->{
    ...,
    "imageUrl": image.asset->url
  },
}`;

const airConditionsUrl = `https://${sanityProjectId}.api.sanity.io/v1/data/query/${sanityDataset}?query=${encodeURIComponent(
  queryAirConditions
)}`;

const servicesPricingUrl = `https://${sanityProjectId}.api.sanity.io/v1/data/query/${sanityDataset}?query=${encodeURIComponent(
  queryServicesPricing
)}`;

const fetchAirConditions = () => {
  return requestConfigurator
    .get(airConditionsUrl)
    .then((response) => {
      return response.data.result[0];
    })
    .catch((error) => {
      return error;
    });
};

const fetchServicesPricing = () => {
  return requestConfigurator
    .get(servicesPricingUrl)
    .then((response) => {
      return response.data.result[0];
    })
    .catch((error) => {
      return error;
    });
};

export const SanityService = {
  getAirConditionPricing: () => {
    return fetchAirConditions();
  },
  getServicesPricing: () => {
    return fetchServicesPricing();
  },
};
